export default "__VITE_PUBLIC_ASSET__ba2c1e0a__"